import { render, staticRenderFns } from "./df-page-news.vue?vue&type=template&id=13b5624a"
import script from "./df-page-news.ts?vue&type=script&lang=js&external"
export * from "./df-page-news.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports